/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

const StyledSearchContainer = styled.div`
  display: flex;
  border: 1px solid ${COLORS.GRAY_600};
  background: ${COLORS.GRAY_800};
  border-radius: 0.5rem;
  align-items: center;
`;

export default StyledSearchContainer;
